import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { get } from '../apiService';

export interface Department {
  id: string;
  name: string;
}

export interface DepartmentsResponse {
  departments: string[] | Department[];
  status?: string;
}

export const getDepartments = async (
  tablespace: string
): Promise<DepartmentsResponse> => {
  if (!tablespace || tablespace.trim() === '') {
    throw new Error('Tablespace is required');
  }

  const customerId = getCustomerIdFromToken();
  if (!customerId) {
    throw new Error('Customer ID is not available');
  }

  try {
    const url = `/resourceMatrix/departments/list?customerId=${encodeURIComponent(
      customerId
    )}&tablespace=${encodeURIComponent(tablespace.trim())}`;
    const response = await get<DepartmentsResponse>(url);
    return response;
  } catch (error) {
    console.error('[getDepartments] API call failed:', error);
    throw new Error(
      `Failed to fetch departments: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`
    );
  }
};

